// instrument.ts — initialisation Sentry frontend (côté navigateur).
// ⚠️ DOIT être importé en TOUT PREMIER dans main.tsx (avant React), pour que
// Sentry puisse instrumenter le runtime au plus tôt.
//
// Sentry frontend capture :
//   - Erreurs JavaScript non gérées (window.onerror)
//   - Promesses rejetées non gérées (unhandledrejection)
//   - Erreurs React (via ErrorBoundary explicite, à utiliser en complément)
//
// Politique RGPD : sendDefaultPii=false (pas d'IP utilisateur ni user-agent).

import * as Sentry from '@sentry/react';

const dsn = import.meta.env['VITE_SENTRY_DSN'];
const environment =
  import.meta.env['VITE_SENTRY_ENVIRONMENT'] ?? import.meta.env.MODE ?? 'development';

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    sampleRate: 1.0,
    // Performance monitoring : 10% en prod, 100% en dev
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    // RGPD : pas d'IP, pas de user-agent complet
    sendDefaultPii: false,
    // Réplique côté frontend du filtre 4xx du backend : ignore les erreurs réseau
    // 4xx (ApiError avec status 4xx) qui sont des erreurs métier, pas des bugs.
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error && typeof error === 'object' && 'status' in error) {
        const status = (error as { status?: number }).status;
        if (typeof status === 'number' && status >= 400 && status < 500) {
          return null;
        }
      }
      return event;
    },
  });
  // eslint-disable-next-line no-console
  console.log(`[Sentry frontend] Initialisé (env: ${environment})`);
} else if (import.meta.env.PROD) {
  // eslint-disable-next-line no-console
  console.warn('[Sentry frontend] VITE_SENTRY_DSN absent en production — erreurs non capturées');
}
